import {Table} from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
import { addCount, sortName, addCount2 } from './store.js'
import { Button } from 'react-bootstrap'


function Cart(){

    let state = useSelector((state) => state) 
    // console.log(state.cart[0].name);

    // dispatch는  store.js 로 요청보내주는 함수
    let dispatch = useDispatch()

    let button = {
        border:"none",
        padding:"6px 10px",
        backgroundColor:"#fff",
        marginRight:"4px"

    }
   return(
     <div className='container'>
       <h3>{state.user.name} {state.user.age} Cart</h3> 
       {/* <button onClick={()=>{ dispatch(increase())}}>나이+</button>
       <button onClick={()=>{ dispatch(increase(100))}}>나이+</button> */}

    <Table>
        <thead>
            <tr>
                <th>Number</th>
                <th>Product</th>
                <th>Count</th>
                <th>Quantity Control</th>
            </tr>
        </thead>
        <tbody>
      
            {
                state.cart.map((a, i)=>
                <tr key={i}>
                    <td>{state.cart[i].id}</td>
                    <td>{state.cart[i].name}</td>
                    <td>{state.cart[i].count}</td>
                    <td><button style={button} onClick={()=>{
                        dispatch(addCount(state.cart[i].id))
                    }}>+</button>
                    <button style={button} onClick={()=>{
                        dispatch(addCount2(state.cart[i].id))
                    }}>-</button>
                    </td>
                    
                </tr>
                )
            }

        </tbody>
       </Table> 
       <Button  variant="outline-success" onClick={()=>{
         dispatch(sortName(state.cart.Name))
       }}>
       Sort by name</Button>{' '}
     </div>

   )

}

export default Cart